import React from 'react';
import {
  BookA,
  BookOpen,
  CalendarDays,
  CircleCheckBig,
  ClipboardCheck,
  Gamepad2,
  GraduationCap,
  Headset,
  Inbox,
  Lightbulb,
  Lock,
  MessagesSquare,
  NotebookText,
  SearchX,
  Star,
  TriangleAlert,
} from 'lucide-react';

/**
 * The icon for what an empty or error state is about (spec §3.12). The CRM is a work tool, so it
 * shows a plain icon here, not the platform's panda mascot.
 *
 *   empty (nothing yet, the default) · search (no results) · error · lock (forbidden)
 *   calendar · students · support · docs · idea · success · exam · game · messages · reviews · courses
 *   vocabulary
 */
const STATE_ICONS = {
  empty: Inbox,
  search: SearchX,
  error: TriangleAlert,
  lock: Lock,
  calendar: CalendarDays,
  students: GraduationCap,
  support: Headset,
  docs: NotebookText,
  idea: Lightbulb,
  success: CircleCheckBig,
  exam: ClipboardCheck,
  game: Gamepad2,
  messages: MessagesSquare,
  reviews: Star,
  courses: BookOpen,
  vocabulary: BookA,
};

/** The chip tone a kind asks for; the rest take the caller's default. */
const STATE_TONES = { error: 'danger', success: 'success' };

export const STATE_KINDS = Object.keys(STATE_ICONS);

export function stateIcon(kind) {
  const Icon = STATE_ICONS[kind] || STATE_ICONS.empty;
  return <Icon aria-hidden="true" />;
}

export function stateTone(kind, fallback) {
  return STATE_TONES[kind] || fallback;
}
